const ImportReturnBillValidation = (selectedRows) => {
  let errors = {};

  for (let x = 0; x < selectedRows.length; x++) {
    console.log("Selected Rows qty :", selectedRows[x]);
    if (selectedRows[x].bill_qty === 0 || selectedRows[x].bill_qty === "") {
      errors._items = "Bill items return qty can not be emtpy or 0";
    }
  }

  return errors;
};

export default ImportReturnBillValidation;
